module.exports = ".margin-top-10 {\r\n  margin-top: 10px;\r\n}\r\n.notificationrole .fancy-checkbox {\r\n  margin: 0;\r\n  padding-top: 17px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/notification-components/edit-notification/edit-notification.component.css
// module id = ./src/app/notification-components/edit-notification/edit-notification.component.css
// module chunks = main